import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import en from '@/locales/en.json'
import ru from '@/locales/ru.json'

export const SUPPORTED_LOCALES = ['en', 'ru'] as const
export type Locale = (typeof SUPPORTED_LOCALES)[number]

void i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    ru: { translation: ru },
  },
  lng: 'en',
  fallbackLng: 'en',
  interpolation: { escapeValue: false }, // React already escapes
})

// Keeps the client language in step with the server-shared locale prop.
export function syncLocale(locale: string) {
  if (!locale) return
  if (i18n.language !== locale) void i18n.changeLanguage(locale)
  if (document.documentElement.lang !== locale) document.documentElement.lang = locale
}

export default i18n
